import { ActionIcon, Tooltip } from '@mantine/core';
import { IconServer, IconAlertCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface StatusBadgeProps {
  status: string;
  version: string | null;
  isLoading: boolean;
  onRecheck?: () => void;
}

export const StatusBadge = ({ status, version, isLoading, onRecheck }: StatusBadgeProps) => {
  const { t } = useTranslation();
  const isOk = status === 'ok';
  const tooltipLabel = `${t(isOk ? 'status.details' : 'status.systemsDown')}${
    version ? ` - ${t('home.version')} ${version}` : ''
  }${!isOk ? ` - ${t('status.clickToRefresh')}` : ''}`;

  return (
    <Tooltip label={tooltipLabel}>
      <ActionIcon
        variant="subtle"
        color={isOk ? 'green' : 'red'}
        onClick={!isOk ? onRecheck : undefined}
        loading={isLoading}
        style={!isOk ? { cursor: 'pointer' } : undefined}
      >
        {isOk ? <IconServer size={20} /> : <IconAlertCircle size={20} />}
      </ActionIcon>
    </Tooltip>
  );
};
